/* eslint-disable */
import listing from "@/apollo/flights/bookings/reports/listing.gql";
import un_hold_inventory from "@/apollo/flights/bookings/reports/un_hold_inventory.gql";
import revised_hold_time from "@/apollo/flights/bookings/reports/revised_hold_time.gql";
import booking_passengers from "@/apollo/flights/bookings/reports/booking_passengers.gql";
import update_booking_passengers from "@/apollo/flights/bookings/reports/update_booking_passengers.gql";
import booking_add_seats from "@/apollo/flights/bookings/reports/booking_add_seats.gql";
import update_dpt_number from "@/apollo/flights/bookings/reports/update_dpt_number.gql";
import context_data from "@/apollo/flights/bookings/reports/context_data.gql";
import cancellation from "@/apollo/flights/bookings/reports/cancellation.gql";

export const state = () => ({
  list: [],
  loading: false
});

export const mutations = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 12 Oct 2023 | 02:56PM
   * @param {*} state
   * @param {*} value
   */
  setListing: (state, value) => (state.list = value),

  /**
   * @description
   * @author Saurabh Jangra
   * @date 12 Oct 2023 | 02:56PM
   * @param {*} state
   * @param {*} value
   */
  setLoading: (state, value) => (state.loading = value)
};

export const actions = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 12 Oct 2023 | 02:56PM
   * @param {*} { commit }
   * @returns {*}
   */
  fetchListing({ commit }) {
    commit("setLoading", true);
    commit("setListing", []);
    return new Promise((resolve) => {
      this.$apolloClient
        .query({ query: listing })
        .then(({ data }) => {
          commit("setListing", data.flt_inventory_booking_reports);
          resolve(data.flt_inventory_booking_reports);
          commit("setLoading", false);
        })
        .catch((err) => {
          commit("setLoading", false);
        });
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 16 Oct 2023 | 04:35PM
   * @param {*} { commit }
   * @returns {*}
   */
  refreshListing({ commit }) {
    return new Promise(async (resolve) => {
      const _result = this.$subscribeClient.iterate({
        query: `subscription { refresh_flt_inventory_bookings }`
      });
      for await (const event of _result) {
        commit("setLoading", true);
        this.$apolloClient.query({ query: listing }).then(({ data }) => {
          commit("setListing", data.flt_inventory_booking_reports);
          commit("setLoading", false);
          resolve(data.flt_inventory_booking_reports);
        });
      }
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 24 Oct 2023 | 12:09PM
   * @param {*} __
   * @param {*} payload
   * @returns {*}
   */
  unHoldInventory(__, payload) {
    return new Promise(async (resolve) => {
      const {
        data: { flt_release_hold_inventory }
      } = await this.$apolloClient.mutate({ mutation: un_hold_inventory, variables: { payload } });
      resolve(flt_release_hold_inventory);
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 26 Oct 2023 | 12:30PM
   * @param {*} __
   * @param {*} payload
   * @returns {*}
   */
  revisedHoldTime(__, payload) {
    return new Promise(async (resolve) => {
      const {
        data: { flt_revised_hold_time }
      } = await this.$apolloClient.mutate({ mutation: revised_hold_time, variables: { payload } });
      resolve(flt_revised_hold_time);
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 30 Oct 2023 | 02:51PM
   * @param {*} __
   * @param {*} payload
   * @returns {*}
   */
  fetchPassengers(__, booking_id) {
    return new Promise(async (resolve) => {
      const {
        data: { flt_inventory_booking_passengers }
      } = await this.$apolloClient.query({ query: booking_passengers, variables: { booking_id } });
      resolve(flt_inventory_booking_passengers);
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 18 Nov 2023 | 03:22PM
   * @param {*} __
   * @param {*} booking_id
   * @returns {*}
   */
  fetchContextData(__, payload) {
    return new Promise(async (resolve) => {
      const {
        data: { flt_inventory_booking_context }
      } = await this.$apolloClient.query({ query: context_data, variables: { payload } });
      resolve(flt_inventory_booking_context);
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 31 Oct 2023 | 03:18PM
   * @param {*} __
   * @param {*} payload
   * @returns {*}
   */
  updatePassengers(__, payload) {
    return new Promise(async (resolve) => {
      const {
        data: { flt_booking_update_passengers }
      } = await this.$apolloClient.mutate({ mutation: update_booking_passengers, variables: { payload } });
      resolve(flt_booking_update_passengers);
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 02 Nov 2023 | 04:52PM
   * @param {*} __
   * @param {*} payload
   * @returns {*}
   */
  addBookingSeats(__, payload) {
    return new Promise(async (resolve) => {
      const {
        data: { flt_booking_add_seats }
      } = await this.$apolloClient.mutate({ mutation: booking_add_seats, variables: { payload } });
      resolve(flt_booking_add_seats);
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 18 Nov 2023 | 11:16AM
   * @param {*} __
   * @param {*} payload
   * @returns {*}
   */
  updateDptNumber(__, payload) {
    return new Promise(async (resolve) => {
      const {
        data: { flt_update_booking_dpt_details }
      } = await this.$apolloClient.mutate({ mutation: update_dpt_number, variables: { payload } });
      resolve(flt_update_booking_dpt_details);
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 02 Dec 2023 | 11:50AM
   * @param {*} __
   * @param {*} payload
   * @returns {*}
   */
  cancelBooking(__, payload) {
    return new Promise(async (resolve) => {
      const {
        data: { flt_booking_cancellation }
      } = await this.$apolloClient.mutate({ mutation: cancellation, variables: { payload } });
      resolve(flt_booking_cancellation);
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 16 Dec 2023 | 02:20PM
   * @param {*} __
   * @param {*} payload
   * @returns {*}
   */
  updatePassengerPassport(__, payload) {
    return new Promise(async (resolve) => {
      const {
        data: { flt_booking_cancellation }
      } = await this.$apolloClient.mutate({ mutation: cancellation, variables: { payload } });
      resolve(flt_booking_cancellation);
    });
  }
};

export const getters = {
  list: (state) => state.list,
  loading: (state) => state.loading
};
